import React, { useEffect, useState, useMemo } from "react";
import { api } from "@/lib/api";
import Navbar from "./platform/Navbar";
import Hero from "./platform/Hero";
import DualPillar from "./platform/DualPillar";
import EcosystemFeatures from "./platform/EcosystemFeatures";
import PricingPlans from "./platform/PricingPlans";
import TurnkeyAndPorting from "./platform/TurnkeyAndPorting";
import BoostersAndFees from "./platform/BoostersAndFees";
import Faq from "./platform/Faq";
import FinalCta from "./platform/FinalCta";

/**
 * Solunary SaaS landing page — composition fine de sous-composants.
 * État (plans/skus/boosters/fees + currency/billing) géré ici, distribué via props.
 * Avant B16 : 610 lignes monolithiques · Après : 50 lignes + 9 sous-composants <120 lignes chacun.
 */
export default function PlatformLanding() {
  const [plans, setPlans] = useState([]);
  const [skus, setSkus] = useState([]);
  const [boosters, setBoosters] = useState([]);
  const [platformFees, setPlatformFees] = useState([]);
  const [currency, setCurrency] = useState("usd");
  const [billing, setBilling] = useState("monthly");

  useEffect(() => {
    document.title = "Solunary — The AI OS where alternative health and education work as one";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Built for those who heal and teach. The AI operating system for modern wellness practitioners — manage clients, run courses, build communities, scale your healing impact.");
    Promise.all([
      api.get("/saas/plans"),
      api.get("/saas/skus"),
      api.get("/saas/boosters"),
      api.get("/saas/platform-fees"),
    ]).then(([p, s, b, f]) => {
      setPlans(p.data || []);
      setSkus(s.data || []);
      setBoosters(b.data || []);
      setPlatformFees(f.data || []);
    });
  }, []);

  // Mémoïse le filtre pour éviter de recréer le tableau à chaque render
  const installSkus = useMemo(() => skus.filter((s) => s.category === "install"), [skus]);
  const portingSkus = useMemo(() => skus.filter((s) => s.category === "data_porting"), [skus]);

  return (
    <div className="min-h-screen bg-sol-ivory text-sol-midnight font-sol-body selection:bg-sol-gold/40 selection:text-sol-midnight">
      <Navbar />
      <Hero />
      <DualPillar />
      <EcosystemFeatures />
      {/* BUG-205 — `skus` / `platformFees` reach the pricing section and the FAQ because
          both state pricing FACTS in prose (the default-funnel total, the annual saving,
          the porting prices, the seat overage, the rate on client payments). Those facts
          used to be typed into JSX literals and into the locale strings, so they drifted
          from these very payloads the moment anyone edited a plan or a catalogue row.
          They are derived from them now — `platform/pricingFacts.js`. */}
      <PricingPlans
        plans={plans}
        skus={skus}
        currency={currency}
        setCurrency={setCurrency}
        billing={billing}
        setBilling={setBilling}
      />
      <TurnkeyAndPorting installSkus={installSkus} portingSkus={portingSkus} currency={currency} />
      <BoostersAndFees boosters={boosters} platformFees={platformFees} currency={currency} />
      <Faq plans={plans} skus={skus} platformFees={platformFees} currency={currency} />
      <FinalCta />
    </div>
  );
}
